import { useContext } from 'react';

import { Skeleton } from '@mui/material';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { DashboardContext } from '../../context/DashboardContext';
import ErrorModal from '../ErrorModal';
import DashboardLayout from '../layout/DashboardLayout';
import DashboardClassView from './DashboardClassView';
import NoSessionsDashboardView from './NoSessionsDashboardView';
import DashboardStudentView from './student/DashboardStudentView';

const View = styled.div``;

const SkeletonsDiv = styled.div`
    margin: 60px 30px;
`;

const SkeletonCirclesDiv = styled.div`
    display: flex;
    width: 70%;
    justify-content: space-between;
    margin: auto auto;
`;
const StyledSkeletonCircle = styled(Skeleton)`
    width: 100px;
    height: 100px;
`;

const StyledSkeletonRectangle = styled(Skeleton)`
    height: 250px;
    margin-top: 33px;
`;

const StyledRowSkeleton = styled(Skeleton)`
    height: 50px;
    margin-bottom: 10px;
`;

const renderClassSkeleton = () => (
    <SkeletonsDiv>
        <SkeletonCirclesDiv>
            <StyledSkeletonCircle variant="circular" animation="wave" />
            <StyledSkeletonCircle variant="circular" animation="wave" />
            <StyledSkeletonCircle variant="circular" animation="wave" />
        </SkeletonCirclesDiv>
        <StyledSkeletonRectangle variant="rectangular" animation="wave" />
    </SkeletonsDiv>
);

const renderStudentSkeleton = () => (
    <SkeletonsDiv>
        <StyledRowSkeleton animation="wave" />
        <StyledRowSkeleton animation="wave" />
        <StyledRowSkeleton animation="wave" />
        <StyledRowSkeleton animation="wave" />
    </SkeletonsDiv>
);

const DashboardView: React.FC = () => {
    const { view, isLoading, sessions, openErrorModal, setOpenErrorModal, errorMessage } =
        useContext(DashboardContext);
    const history = useHistory();

    const renderDashboardView = () => {
        if (!isLoading && sessions.length < 1) {
            return <NoSessionsDashboardView/>;
        }
        switch (view) {
            case 'StudentDetail': {
                return isLoading || openErrorModal ? renderStudentSkeleton() : <DashboardStudentView />;
            }
            case 'SessionSummary': {
                return isLoading || openErrorModal ? renderClassSkeleton() : <DashboardClassView />;
            }
            default:
                return null;
        }
    };

    return (
        <DashboardLayout>
            <View>
                {renderDashboardView()}
                <ErrorModal
                    open={openErrorModal}
                    onClose={() => {
                        setOpenErrorModal(false);
                        window.close();
                    }}
                    tryAgain
                    onTryAgain={() => history.go(0)}
                >
                    {errorMessage}
                </ErrorModal>
            </View>
        </DashboardLayout>
    );
};

export default DashboardView;
